import React, { useState } from 'react';
import './Delay.css';

const DelayModel = () => {
  const [input, setInput] = useState(0);
  const [baseBillions, setBaseBillions] = useState(6);
  const baseCost = baseBillions * 1_000_000_000;
  const total = baseCost * Math.pow(1.1, Number(input) / 12);
  const delayCost = total - baseCost;
  return (
    <div className="container">
      <div className="input-row">
        <label htmlFor="base-cost">Base Cost:</label>
        <span>$</span>
        <input
          id="base-cost"
          type="number"
          value={baseBillions}
          onChange={(e) => setBaseBillions(Number(e.target.value))}
        />
        <span>B</span>
      </div>
      <h3 className="reactor-size">Delay Cost: {delayCost.toLocaleString(undefined, { style: 'currency', currency: 'USD' })}</h3>
      <div className="center-content">
        <h1>{total.toLocaleString(undefined, { style: 'currency', currency: 'USD' })}</h1>
          <div className="input-row">
            <label htmlFor="delay-input">Months of Delay:</label>
            <input
            id="delay-input"
            type="number"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            />
        </div>
      </div>
    </div>
  );
};

export default DelayModel;
